import { collection, query, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../config/firebase";
import type { Feedback } from "../types/firestore";

export function subscribeToFeedback(
  onUpdate: (feedback: Feedback[]) => void,
  onError: (message: string) => void,
): () => void {
  return onSnapshot(
    query(collection(db, "feedback"), orderBy("createdAt", "desc"), limit(500)),
    (snapshot) => {
      onUpdate(
        snapshot.docs.map(
          (docSnap) => ({ id: docSnap.id, ...docSnap.data() }) as Feedback,
        ),
      );
    },
    (error) => {
      console.error("[FeedbackService] Failed to load feedback:", error);
      onError("Failed to load feedback.");
    },
  );
}
